<template>
  <div
    style="height:100%;background-color: rgb(210, 233, 255,0.5);padding: 14px 20px;box-sizing: border-box;"
  >
    <h2 align="center" style="color: #3b3b3b;">加班信息表</h2>
    <el-row>
      <div class="block" width="50%" style="display:inline-block;float:left">
        <data-time @datachange="timechange"></data-time>
        <div style="display:inline-block">
          <el-button type="danger" size="small" @click="checkedDelete" v-if="timeFlag=='open'">
            批量删除
            <i class="el-icon-delete"></i>
          </el-button>
          <el-button size="small" @click="handleAdd" type="primary" v-if="timeFlag=='open'">新增加班记录</el-button>
        </div>
      </div>
      <div style="display:inline-block;float:right">
        <el-button @click="exportToExcel" size="small" type="success">导出表格</el-button>
        <el-button size="small" @click="gotohome" type="primary">《《 返回首页</el-button>
      </div>
    </el-row>
    <get-table
      :CtableData.sync="tableData"
      @getdata="getstage"
      ref="diaoyong"
      :CtimeFlag.sync="timeFlag"
      style="height:74%"
    ></get-table>
  </div>
</template>
<script>
import DataTime from "@/base/DataTime";
import GetTable from "./GetTable";
import axios from "axios";
import { showLoading, hideLoading } from "@/lib/loading";
import {
  hourToMin,
  getTaskOptionValue,
  gettasklistStrName,
  backHome,
  getlistname,
  getlistproject,
  gettaskOptions,
  getpsheList
} from "@/lib/until";
export default {
  name: "person",
  components: {
    DataTime,
    GetTable
  },
  data() {
    return {
      nowtime: "",
      personId: "",
      options: [],
      tableData: [],
      timeFlag: "open"
    };
  },
  created() {
    this.getuserInfo();
  },
  methods: {
    getstage(jieduan, baseInfo) {
      this.getDatajieduan = jieduan;
      this.base_info = baseInfo;
      //console.log(opt);
      //console.log(jieduan);
    },
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      this.personId = uesrInfo.employee_id;
      this.password = uesrInfo.password;
      //console.log(this.depart_id);
    },
    exptime(data1) {
      axios
        .get(IPConfig.IP + "/kpi-management/ppdata/paydate.php")
        .then(res => {
          //console.log(res.data);
          if (0 == res.data.errcode) {
            if (
              res.data.payment_create_dates &&
              res.data.payment_create_dates.length > 0
            ) {
              var KpiDayList = res.data.payment_create_dates;
              var LastDay = KpiDayList[0];
              var oDate1 = new Date(data1);
              var oDate2 = new Date(LastDay);
              // var oDate2 = new Date("2020-05-26");
              if (oDate1.getTime() < oDate2.getTime()) {
                this.timeFlag = "close";
                //console.log(this.timeFlag);
              } else {
                this.timeFlag = "open";
              }
            }
          }
        })
        .catch(error => {
          //console.log(error);
        });
    },
    timechange(time) {
      //console.log(time);
      
      this.exptime(time);
      axios
        .get(IPConfig.IP + "/kpi-management/info/overtime_report_info.php", {
          params: {
            employee_id: this.personId,
            overtime_report_date: time,
            //params: { encodeout: "utf-8" }

          }
        })
        .then(data => {
          showLoading();
          //console.log(data.data);
          this.tableData = [];
          var searchMsg = data.data;

          var valueList = Object.values(searchMsg.overtime_report_list);
          //console.log(valueList);
          this.search(valueList);
        })
        .catch(error => {
          //console.log(error);
          hideLoading();
        });
    },
    search(getDailyMsg) {
      if (typeof getDailyMsg == "undefined" || getDailyMsg.length <= 0) {
        hideLoading();
        return;
      }
      //console.log(getDailyMsg);
      var tableList = [];
      for (var i = 0; i < getDailyMsg.length; i++) {
        let vms = getDailyMsg[i];
        //获取部门名字
        for (let key in this.base_info.depart_list) {
          //console.log(key);
          if (vms.depart_id == key) {
            vms["bumencn"] = this.base_info.depart_list[key].depart_name;
          }
        }
        //获取阶段名字
        for (let key in this.base_info.project_list) {
          if (vms.project_id == key) {
            vms["xiangmucn"] = this.base_info.project_list[key].project_name_cn;
          }
        }

        getpsheList(vms).then(res => {
          //console.log(res);
          vms["chioes"] = gettaskOptions(vms.depart_id, this.base_info, res);
          let chioseList = vms["chioes"];
          vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
          var taskoptions = this.base_info.depart_all_task_list[vms.depart_id];
          var scopeName = [];
          Object.assign(scopeName, vms["value1"]);
          if (scopeName.length > 0) {
            vms["task_name_str"] = gettasklistStrName(
              vms.task_id,
              scopeName,
              taskoptions
            );
          } else {
            vms["task_name_str"] = vms.task_id;
          }

          hourToMin(vms);
          tableList.push(vms);
          tableList = Object.values(tableList).sort(function(a, b) {
            return a.phase_id - b.phase_id;
          });
          this.tableData = tableList;
          hideLoading();
        });
      }
    },
    handleAdd() {
      this.$refs.diaoyong.AddEmtyData();
    },
    checkedDelete() {
      this.$refs.diaoyong.checkedDelete();
    },
    gotohome() {
      backHome(this);
    },
    exportToExcel() {
      this.$refs.diaoyong.exportToExcel();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/PersonOverTime/index.vue